import { render, staticRenderFns } from "./DevisList.vue?vue&type=template&id=2c393d2b&scoped=true"
import script from "./DevisList.vue?vue&type=script&lang=js"
export * from "./DevisList.vue?vue&type=script&lang=js"
import style0 from "./DevisList.vue?vue&type=style&index=0&id=2c393d2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c393d2b",
  null
  
)

export default component.exports